import React, { useEffect, useState, useCallback } from "react";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { getHomeDocuments } from "../../api/firestore/home";
import NotFoundMessage from "../../components/not-found-message";
import Card from "./card";

import StyledHome from "./styles";

const ChatHomePage = () => {
  const [data, setData] = useState(null);

  const setCachedHomeData = useCallback(async (data) => {
    sessionStorage.setItem("homeData", JSON.stringify(data));
  }, []);

  const areCachedCardsExpired = (date) => {
    const currDate = Date.now();

    if (date + 300 * 1000 > currDate) {
      return true;
    }

    return false;
  };

  useEffect(() => {
    const getHomeCardData = async () => {
      let finalCards = null;

      try {
        finalCards = sessionStorage.getItem("homeData");

        if (!finalCards) {
          finalCards = await getHomeDocuments();

          setCachedHomeData({
            cards: finalCards,
            date: Date.now(),
          });
        } else {
          finalCards = JSON.parse(finalCards);

          const { cards, date } = finalCards;

          const areExpired = areCachedCardsExpired(date);

          if (areExpired) {
            finalCards = await getHomeDocuments();

            setCachedHomeData({
              cards: finalCards,
              date: Date.now(),
            });
          } else {
            finalCards = cards;
          }
        }

        setData(finalCards);
      } catch (e) {
        console.log(e);
        finalCards = null;
      }

      setData(finalCards);
    };

    getHomeCardData();
  }, [setCachedHomeData]);

  return (
    <StyledHome>
      <div className="home-page">
        {data ? (
          data.map((card, i) => {
            return <Card key={`card-${i}`} {...card} />;
          })
        ) : (
          <NotFoundMessage
            message="Mmmmmm.... No hay nada que ver"
            Icon={QuestionMarkIcon}
          />
        )}
      </div>
    </StyledHome>
  );
};

export default ChatHomePage;
